<template>
  <div class="filters-row">
    <div class="text-center mb-4"><base-button @click="search" class="w-100">{{$t('filters.showResults')}}</base-button></div>
    <div v-if="showSubscriptorsFilter">
        <div><base-checkbox noMargin v-model="filters.onlySubscription.value"><span v-html="$t('filters.subscriptionIncluded')"></span></base-checkbox></div>
    </div>
    <div v-if="$route.query.anyInsurer === '1'">
        <div><base-checkbox noMargin v-model="filters.anyInsurer.value"><span v-html="$t('filters.anyInsurer')"></span></base-checkbox></div>
    </div>
    <div>
      <hr v-if="showSubscriptorsFilter || $route.query.anyInsurer === '1'">
      <base-select :options="filters.userType.options" avoidDefaultSort valueProp="id" label="name" v-model="filters.userType.value" @input="userTypeSelected"></base-select>
    </div>
    <div v-if="!hideSpecialtiesFilter">
      <hr>
      <base-select searchable :filter="specialtyAndUserFilter" clearable avoidDefaultSort :loading="filters.specialtyAndUser.loading" :options="filters.specialtyAndUser.options" valueProp="id" label="name" v-model="filters.specialtyAndUser.value" @input="specialtyAndUserSelected" @search="searchUserByName($event)" :placeholder="filters.specialtyAndUser.placeholder">
        <template #option="data">
          <div v-if="isNumber(data.option.value)">
            <span>{{data.option.label}}</span>
          </div>
          <div v-else>
            <img class="photo-option" :src="getUserPhoto(data.option.value)" /> <span>{{data.option.label}}</span>
          </div>
        </template>
      </base-select>
    </div>
    <hr>
    <div>
      <base-select :loading="filters.appointmentType.loading" clearable :options="filters.appointmentType.options" avoidDefaultSort valueProp="id" label="name" v-model="filters.appointmentType.value" @input="appointmentTypeFilterChange" :placeholder="filters.appointmentType.placeholder"></base-select>
    </div>
    <div v-if="!hideServicesFilter">
      <hr>
      <div><base-select @search="loadServices($event)" :noOptionsTitle="servicesNoOptionsTitle" searchable clearable :loading="filters.service.loading" :options="filters.service.options" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" @input="serviceFilterChange" v-model="filters.service.value" :placeholder="filters.service.placeholder"></base-select></div>
    </div>
    <hr>
    <div><base-select searchable clearable :loading="filters.location.loading" :options="filters.location.options" valueProp="id" label="name" v-model="filters.location.value" @input="locationSelected" :placeholder="filters.location.placeholder"></base-select></div>
    <div v-if="showMoreFilters">
      <hr>
      <div><base-select @search="loadSubspecialties($event)" clearable searchable :loading="filters.subspecialty.loading" :options="filters.subspecialty.options" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" v-model="filters.subspecialty.value" :placeholder="filters.subspecialty.placeholder"></base-select></div>
      <!-- <div v-if="!hideInsurancesFilter">
        <hr>
        <div><base-select searchable clearable :loading="filters.insurance.loading" :options="filters.insurance.options" valueProp="id" label="name" v-model="filters.insurance.value" @open="$store.dispatch('showInfoAlert', $t('filters.insuranceAdvice'))" :placeholder="filters.insurance.placeholder"></base-select></div>
      </div> -->
      <div v-if="!hideDiseasesFilter">
        <hr>
        <div><base-select @search="loadDiseases($event)" clearable searchable :loading="filters.disease.loading" :options="filters.disease.options" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" v-model="filters.disease.value" :placeholder="filters.disease.placeholder"></base-select></div>
      </div>
      <hr>
      <div><base-datepicker no-margin-bottom resetButtton v-model="filters.date.value" dateAfterNow></base-datepicker></div>
      <hr>
      <div><base-select searchable clearable :loading="filters.language.loading" :options="filters.language.options" valueProp="id" label="name" v-model="filters.language.value" :placeholder="filters.language.placeholder"></base-select></div>
      <div v-if="profFilterSelected">
        <hr>
        <div><base-input zeroMarginBottom v-model="filters.coupon.value" :placeholder="filters.coupon.placeholder"></base-input></div>
      </div>
      <hr>
      <div class="text-center"><base-radio-group :options="filters.timeOfDay.options" v-model="filters.timeOfDay.value"></base-radio-group></div>
      <div v-if="!hidePricesFilter" class="mt-3 mb-5">
        <span v-html="`${$t('filters.priceMinorTo')} ${filters.price.value}${currency}`"></span>
        <vue-slider v-model="filters.price.value" :min="5" :max="1000" :interval="5" :marks="[5, 200, 400, 600, 800, 1000]" tooltip="none" :tooltipStyle="{'font-weight': 'bold', width: 'max-content'}" :tooltip-formatter="`${$t('filters.priceMinorTo')} ${filters.price.value}${currency}`" :railStyle="{ backgroundColor: '#FFFFFF' }"></vue-slider>
      </div>
    </div>
    <div :class="{'my-3': !showMoreFilters}" class="text-center">
      <b-row>
        <b-col v-if="!showMoreFilters" cols="6" @click="showMoreFilters = true"><b-icon-plus-circle class="blue pointer"></b-icon-plus-circle> <span class="pointer" v-html="$t('filters.showMoreFilters')"></span></b-col>
        <b-col v-if="showMoreFilters" cols="6" @click="showMoreFilters = false"><b-icon-dash-circle class="red pointer"></b-icon-dash-circle> <span class="pointer" v-html="$t('filters.hideFilters')"></span></b-col>
        <b-col cols="6" @click="removeFilters()"><b-icon-x-circle class="red pointer"></b-icon-x-circle> <span class="pointer" v-html="$t('filters.removeFilters')"></span></b-col>
      </b-row>
    </div>
    <div v-if="showMoreFilters" :class="{'mb-3': mobileVersion}" class="text-center mt-4"><base-button @click="search" class="w-100">{{$t('filters.showResults')}}</base-button></div>
  </div>
</template>

<script>
import specialitiesRepository from '@/repositories/SpecialitiesRepository'
import searchRepository from '@/repositories/SearchRepository'
import appointmentTypesRepository from '@/repositories/ConsultationTypesRepository'
import insurersRepository from '@/repositories/InsurersRepository'
import subspecialitiesRepository from '@/repositories/SubspecialitiesRepository'
import healthServicesRepository from '@/repositories/HealthServicesRepository'
import geographyRepository from '@/repositories/GeographyRepository'
import languageRepository from '@/repositories/LanguageRepository'
import diseasesRepository from '@/repositories/DiseasesRepository'
import { PROFESSIONAL, CENTER } from '@/constants/search'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker.vue'
import VueSlider from 'vue-slider-component'
import { VIDEO, INPLACE, WRITTEN, SECOND_OPINION, IMMEDIATE_VIDEO, AT_HOME, CHAT, CALL } from '@/constants/consultationTypes'
import { getCurrencyByDomain } from '@/constants/currencies'
import { SCREEN_LG_GRID } from '@/constants/mediaQueries'
import { PROFESSIONAL_MALE_DEFAULT_IMAGE, CENTER_DEFAULT_IMAGE } from '@/constants/images'
import { checkIgnoringNonRelevantCharactersFromOptionLabel } from '@/helpers/string.helpers'

export default {
  components: {
    BaseDatepicker,
    VueSlider
  },
  props: {
    showIncludedInSubscriptionFilter: Boolean
  },
  data () {
    return {
      filters: {
        specialtyAndUser: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.specialityOrName'),
          value: null
        },
        subspecialty: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.subspeciality'),
          value: null
        },
        disease: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.disease'),
          value: null
        },
        language: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.language'),
          value: null
        },
        appointmentType: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.consultationsType'),
          value: null,
          order: [INPLACE, VIDEO, WRITTEN, CHAT, SECOND_OPINION, IMMEDIATE_VIDEO, AT_HOME, CALL]
        },
        service: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.tests'),
          value: null
        },
        price: {
          value: 1000,
          defaultValue: 1000
        },
        insurance: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.insurance'),
          value: null
        },
        timeOfDay: {
          options: [{text: this.$t('filters.morning'), value: 1}, {text: this.$t('filters.afternoon'), value: 2}],
          value: null
        },
        location: {
          loading: false,
          options: [],
          placeholder: this.$t('filters.location'),
          value: null
        },
        onlySubscription: {
          value: null
        },
        onlyBonified: {
          value: null
        },
        date: {
          value: null
        },
        servicesPackages: {
          value: null
        },
        flatRateWebmail: {
          value: null
        },
        tests: {
          value: null
        },
        coupon: {
          placeholder: this.$t('filters.coupon'),
          value: null
        },
        userType: {
          value: PROFESSIONAL,
          options: [{name: this.$t('professionals'), id: PROFESSIONAL}, {name: this.$t('centers'), id: CENTER}],
          defaultValue: PROFESSIONAL
        },
        anyInsurer: {
          value: null
        }
      },
      specialty: {
        options: [],
        value: null
      },
      showMoreFilters: false,
      showInsuranceModal: false,
      PROFESSIONAL,
      CENTER,
      hideSpecialtiesFilter: false,
      hideServicesFilter: false,
      hideInsurancesFilter: false,
      hideDiseasesFilter: false,
      hidePricesFilter: false,
      servicesNoOptionsTitle: this.$t('filters.enterWord'),
      showAllProfessionals: null
    }
  },
  created () {
    if (!this.$store.getters['session/userIsPatient'] && !this.$route.query.api_token && !this.$apiToken) {
      this.$router.push('error/unauthorized')
      return
    }
    if (Object.keys(this.$route.query).length > 0) {
      if (this.$route.query.specialty) {
        this.filters.specialtyAndUser.value = parseInt(this.$route.query.specialty)
        this.specialty.value = this.filters.specialtyAndUser.value
      } else {
        this.filters.specialtyAndUser.value = this.$route.query.profId || null
      }
      if (this.$route.query.service) {
        this.filters.service.value = this.$route.query.service || null
        this.loadServices()
      }
      this.filters.insurance.value = parseInt(this.$route.query.insurer) || null
      this.filters.location.value = parseInt(this.$route.query.location) || null
      this.filters.appointmentType.value = parseInt(this.$route.query.appointmentType) || null
      this.filters.subspecialty.value = parseInt(this.$route.query.subspecialty) || null
      this.filters.anyInsurer.value = this.$route.query.anyInsurer === '1'
      this.hideSpecialtiesFilter = this.$route.query.hideSpecialtiesFilter === '1'
      this.hideServicesFilter = this.$route.query.hideServicesFilter === '1'
      this.hideInsurancesFilter = this.$route.query.hideInsurancesFilter === '1'
      this.hideDiseasesFilter = this.$route.query.hideDiseasesFilter === '1'
      this.hidePricesFilter = this.$route.query.hidePricesFilter === '1'
      if (this.$route.query.api_token) {
        this.$store.commit('session/setApiToken', this.$route.query.api_token)
      }
      this.search()
      // window.history.replaceState(null, '', window.location.pathname)
    }
    this.loadFilters()
  },
  computed: {
    profFilterSelected () {
      return this.filters.userType.value === PROFESSIONAL
    },
    currency () {
      return getCurrencyByDomain()
    },
    mobileVersion () {
      return window.innerWidth < SCREEN_LG_GRID
    },
    showSubscriptorsFilter () {
      return this.profFilterSelected && this.showIncludedInSubscriptionFilter
    }
  },
  methods: {
    loadFilters () {
      this.loadSpecialties()
      this.loadCities()
      this.loadLanguages()
      this.loadAppointmentTypes()
      this.loadInsurers()
      this.loadSubspecialties(null, true)
      this.loadDiseases(null, true)
    },
    userTypeSelected () {
      this.search()
    },
    isNumber (data) {
      return !isNaN(data)
    },
    loadSpecialties () {
      specialitiesRepository[this.profFilterSelected ? 'getProfSpecialitiesByCity' : 'getCenterSpecialitiesByCity'](this.filters.location.value).then(response => {
        let data = response.data.map(item => { return {id: item.id, name: this.$i18nHelpers.normalize(item.name)} })
        this.specialty.options = data
        this.filters.specialtyAndUser.options = data
      })
    },
    loadCities () {
      if (this.filters.service.value) {
        geographyRepository.getStatesByService(this.filters.service.value).then(response => {
            this.filters.location.options = response.data
        })
      } else {
        geographyRepository[this.profFilterSelected ? 'getProfStates' : 'getCenterStates']({ specialty: this.specialty.value, appointmentType: this.filters.appointmentType.value }).then(response => {
            this.filters.location.options = response.data
        })
      }
    },
    loadLanguages () {
      languageRepository[this.profFilterSelected ? 'getProfLanguagesBySpecialty' : 'getCenterLanguagesBySpecialty'](this.specialty.value).then(response => {
          this.filters.language.options = response.data
      })
    },
    loadAppointmentTypes () {
      appointmentTypesRepository[this.profFilterSelected ? 'getProfConsultationTypes' : 'getCenterConsultationTypes']().then(response => {
        let consultationsTypesSorted = []
        this.filters.appointmentType.order.forEach(id => {
          let consultationItem = response.data.find(con => con.id === id)
          if (consultationItem) consultationsTypesSorted.push({ name: this.$i18nHelpers.normalize(consultationItem.name), id: consultationItem.id })
        })
        this.filters.appointmentType.options = consultationsTypesSorted
      })
    },
    loadInsurers () {
      insurersRepository[this.profFilterSelected ? 'getAllProfInsurers' : 'getAllCenterInsurers']().then(response => {
        this.filters.insurance.options = response.data
      })
    },
    loadDiseases (search, initLoad) {
      if (search || initLoad) {
        diseasesRepository[this.profFilterSelected ? 'getProfDiseases' : 'getCenterDiseases']({name: search, hideLoadingIcon: true}).then((response) => {
          this.filters.disease.options = response.data
          this.filters.disease.loading = false
        })
      }
    },
    loadSubspecialties (search, initLoad) {
      if (search || initLoad) {
        subspecialitiesRepository[this.profFilterSelected ? 'getProfSubspecialities' : 'getCenterSubspecialities']({name: search, specialtyId: this.specialty.value, hideLoadingIcon: true}).then((response) => {
            this.filters.subspecialty.options = response.data
            this.filters.subspecialty.loading = false
        })
      }
    },
    loadServices (search) {
			// Do not call server until there are at least 2 characters
			if ((search === undefined || search.length < 2) && !this.filters.service.value) {
        this.servicesNoOptionsTitle = this.$t('filters.enterWord')
				this.filters.service.options = []
				return
			}
      this.servicesNoOptionsTitle = null
      healthServicesRepository[this.profFilterSelected ? 'getProfHealthServicesByNameAndCity' : 'getCenterHealthServicesByNameAndCity'](search, this.filters.location.value).then((response) => {
          this.filters.service.options = response.data
          this.filters.service.loading = false
      })
    },
    search () {
      let params = {}
      let emptyFilters = Object.keys(this.filters).filter(item => item !== 'userType').every(key => {
        return this.filters[key].defaultValue ? this.filters[key].value === this.filters[key].defaultValue : !this.filters[key].value
      })
      if (emptyFilters) {
        this.$store.dispatch('showInfoAlert', this.$t('filters.selectFilter'))
        return
      }
      Object.keys(this.filters).filter(item => item !== 'specialtyAndUser').forEach(key => { params[key] = this.filters[key].value })
      params[this.isNumber(this.filters.specialtyAndUser.value) ? 'specialty' : 'userId'] = this.filters.specialtyAndUser.value
      this.$emit('search', params)
    },
    searchUserByName (name) {
      if (name && name.length >= 3) {
        searchRepository[this.profFilterSelected ? 'getProfsByName' : 'getCentersByName'](name).then(response => {
          this.filters.specialtyAndUser.options = [...this.specialty.options, ...response.data]
        })
      }
    },
    specialtyAndUserFilter (options, search) {
      if (search) {
        let result = []
        result.push(...options.filter(option => this.isNumber(option.value) && checkIgnoringNonRelevantCharactersFromOptionLabel(option, search) > -1))
        if (search.length >= 3) result.push(...options.filter(option => !this.isNumber(option.value)))
        return result
      } else {
        return this.specialty.options
      }
    },
    getUserPhoto (id) {
      let user = this.filters.specialtyAndUser.options.find(item => item.id === id)
      if (user.photo) {
        return user.photo
      } else {
        return this.profFilterSelected ? PROFESSIONAL_MALE_DEFAULT_IMAGE : CENTER_DEFAULT_IMAGE
      }
    },
    specialtyAndUserSelected () {
      if (this.isNumber(this.filters.specialtyAndUser.value)) {
        this.specialty.value = this.filters.specialtyAndUser.value
        this.loadLanguages()
        this.loadCities()
        this.loadSubspecialties(null, true)
        this.filters.subspecialty.value = null
        this.filters.subspecialty.options = []
      } else {
        this.search()
      }
    },
    locationSelected () {
      this.loadSpecialties()
    },
    removeFilters () {
      Object.keys(this.filters).forEach(key => { this.filters[key].value = this.filters[key].defaultValue ? this.filters[key].defaultValue : null })
    },
    appointmentTypeFilterChange () {
      if (this.filters.appointmentType.value) {
        this.filters.service.value = null
      }
    },
    serviceFilterChange () {
      if (this.filters.service.value) {
        this.filters.appointmentType.value = null
        this.filters.specialtyAndUser.value = null
        this.filters.location.value = null
        this.filters.insurance.value = null
        this.filters.disease.value = null
        this.filters.subspecialty.value = null
      }
      this.loadCities()
    }
  },
  watch: {
    'filters.userType.value' () {
      this.loadFilters()
    },
    showIncludedInSubscriptionFilter (value) {
      if (value) this.$store.dispatch('showSharedDialog', { content: this.$t('subscriptorsAdviceSearch') })
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-row{
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
.red {
  color: $red;
}
.blue {
  color: $blue;
}
.pointer {
  cursor: pointer;
}
.prof-user-selector{
  margin-right: 1rem;
  @include screen-xl-grid-max {
    margin-right: 0;
  }
}
/deep/ .no-border-right{
  input{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
/deep/ .no-border-left{
  input{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
/deep/ .vue-slider-dot {
  background-color: $blue;
  border-radius: 50%;
}
.photo-option{
  border-radius: 100%;
  padding: 0;
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/SearchFilters.vue